export const APP_CONFIG = {
  name: "AI Dash App",
  description: "Smart diagnostic for your vehicle",
  version: "1.0.0",
};

export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || "/api",
  endpoints: {
    analyze: "/analyze",
  },
  timeout: 30000, // 30 seconds
};

export const FILE_CONFIG = {
  acceptedTypes: "image/*",
  maxSize: 10 * 1024 * 1024, // 10MB
  preview: {
    maxWidth: 400,
    quality: 0.8,
  },
};

export const MOCK_RESULT = {
  vehicle: "2005 Chevrolet Astro",
  detectedLights: ["Check Engine", "ABS"],
  possibleCauses: ["Misfire", "Vacuum leak", "Dirty injector"],
  whatToCheck: ["Spark plugs", "Coils", "Hoses"],
  urgency: "Moderate",
  urgencyNote: "Safe to drive short distances but get it checked soon",
};

export const URGENCY_COLORS = {
  low: "text-green-600",
  moderate: "text-yellow-600",
  high: "text-red-600",
};
